import { z } from "zod";

/**
 * Fields editable from the unified "Edit contact info" modal. Mirrors the
 * mockup: gender, name parts, the three contact channels and the booking link.
 * All optional except `id` so partial updates are valid.
 */
export const ContactInfoSchema = z.object({
	id: z.number(),
	firstName: z.string().optional(),
	middleName: z.string().optional(),
	lastName: z.string().optional(),
	gender: z.string().optional(),
	email: z.string().optional(),
	phone: z.string().optional(),
	linkedinUrl: z.string().optional(),
	bookingLink: z.string().optional(),
});

export type ContactInfo = z.infer<typeof ContactInfoSchema>;
